import { Component, OnInit, ViewEncapsulation, AfterViewInit } from '@angular/core';
import { environment as ENV } from '../../../../environments/environment.prod';
import { HttpClient } from '@angular/common/http';
import Swal from 'sweetalert2';
import { Router, NavigationEnd } from '@angular/router';
import { ScriptLoaderService } from '../../../_services/script-loader.service';
import { getCookie, getRootDomain } from '../../../../utils/auth';

declare let mLayout: any;
@Component({
    selector: "app-header-nav",
    templateUrl: "./header-nav.component.html",
    encapsulation: ViewEncapsulation.None,
})
export class HeaderNavComponent implements OnInit, AfterViewInit {

    userData: any;
    env: any;
    baseUrl: any;
    employee_id: any;
    projectList: any;
    selectedProjectId: string;
    projectId: number;
    projectIdName: string;
    redirectUrl: any;
    s3AwsUrl = ENV.s3AwsUrl;
    currentRoute: string;

    constructor(private httpClient: HttpClient, private router: Router, private _script: ScriptLoaderService) {
        var jwt = { token: getCookie('MyToken') };
        this.env = ENV;

        if (!jwt || !jwt.token) {
        }
        else {
            this.httpClient.get(ENV.baseUrl + 'User/getCurrentUserInfo').subscribe((data: any) => {
                this.userData = data.data;
            });
        }

        this.currentRoute = this.router.url;

    }
    ngOnInit() {
        this.projectId = Number(localStorage.getItem("selected_project_id"));
        this.ngAfterViewInit();
        this.baseUrl = ENV.baseUrl;
        this.getProjectList();
        // * Employee Global Search 
        $("#employeeSearchGlobalDashboard").on('change', (e) => {
            if ($("#employeeSearchGlobalDashboard").val() != '') {
                this.employeeAllDetails($("#employeeSearchGlobalDashboard").val());
            }
        })


        //  * Project Change From Header Menu
        $("#change_project").on('change', (e) => {
            let idNumberNew = Number($("#change_project").val());
            if (this.projectId != idNumberNew && idNumberNew != 0) {
                let idNumber: string;
                idNumber = String(idNumberNew);
                this.selectedProjectId = idNumber;
                let key = 'selected_project_id';
                localStorage.setItem(key, this.selectedProjectId);
                if (this.currentRoute == "/") {
                    window.location.assign(ENV.redirectUrl + "/dashboard");
                }
                else {
                    location.reload();
                }
            }
        })
    }

    employeeAllDetails(employeeId: any) {
        window.open(ENV.baseUrl + "DenominationMaster/employeeAllDetails/" + employeeId + "/" + this.projectId + "?token=" + getCookie('MyToken'), "_blank");
    }

    getProjectList() {
        this.httpClient.get(ENV.baseUrl + 'User/getProjectListByAccess').subscribe(data => {
            this.projectList = data['data'];
            // this.selectCurrentProject();
            if (this.projectId) {
                setTimeout(() => {
                    $("#change_project").val(this.projectId);
                    $('#change_project').trigger('change');
                }, 100);
            }
            else {
                this.projectIdName = "Select a project";
            }
        });
    }

    selectCurrentProject() {
        setTimeout(function () { $("#selectProjectFromHeaderNav option[value=" + localStorage.getItem("selected_project_id") + "]").attr("selected", "selected"); }, 100);
    }

    getSelectedProjectId(idNumber: string) {
        this.selectedProjectId = idNumber;
        let key = 'selected_project_id';
        localStorage.setItem(key, this.selectedProjectId);
        location.reload();
    }
    getSelectedProjectIdNew(idNumberNew: number) {
        let idNumber: string;
        idNumber = String(idNumberNew);
        this.selectedProjectId = idNumber;
        let key = 'selected_project_id';
        localStorage.setItem(key, this.selectedProjectId);
        location.reload();
    }

    enterSoftware() {
        this.baseUrl = ENV.baseUrl;
        if (this.selectedProjectId == "") {
            Swal('Warning', "Please Select a Project", 'warning');
        } else {
            let key = 'selected_project_id';
            localStorage.setItem(key, this.selectedProjectId);
            this.router.navigate(['./dashboard']);
        }
    }

    getMenuSubmenuList() {
        this.httpClient.get(ENV.baseUrl + 'User/getUserAllowedPagesByUser').subscribe(data => {
        });
    }

    editProfile() {
        window.open(ENV.loginURL + "#/profile/basic", '_blank');
    }

    logout() {
        document.cookie = 'MyToken=;path=/;domain=' + getRootDomain() + ';expires=' + new Date(0).toUTCString();
        localStorage.removeItem("selected_project_id");
        localStorage.removeItem("userInfo");
        localStorage.removeItem("userInfo");
        localStorage.removeItem("MyToken");
        var redirectUrl = ENV.redirectUrl;
        redirectUrl = btoa(redirectUrl);
        redirectUrl = encodeURIComponent(redirectUrl);
        location.href = ENV.loginURL + "login/index/" + redirectUrl;
    }

    ngAfterViewInit() {
        this._script.loadScripts('app-header-nav',
            ['/assets/demo/default/custom/components/forms/widgets/select2.js']);
        mLayout.initHeader();
    }

}


// WEBPACK FOOTER //
// ./src/app/theme/layouts/header-nav/header-nav.component.ts